import { produce } from 'immer'
import { CountryListResponse } from 'src/models/country.models'
import {
  GET_COUNTRYS_SUCCESS,
  GetCountrysSuccessAction,
} from 'src/redux/actions/data/countrys.actions'

export interface CountrysState {
  listResponses: Record<string, CountryListResponse>
  order: string[]
}

export const initialState: CountrysState = {
  listResponses: {},
  order: [],
}

export type Actions = GetCountrysSuccessAction

const CountrysReducer = (
  state: CountrysState = initialState,
  action: Actions,
): CountrysState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_COUNTRYS_SUCCESS: {
        draft.listResponses = action.payload.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.iso]: curr,
          }),
          {},
        )
        draft.order = action.payload.map((group) => group.iso)
        return draft
      }
    }
  })
}

export default CountrysReducer
